"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
SpeedFilter.$inject = [];
function SpeedFilter() {
    return function (speed) {
        return (speed * 3.6 / 1.852); //from m/s to knot;
    };
}
exports.SpeedFilter = SpeedFilter;
;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/filters/SpeedFilter.js
// module id = 599
// module chunks = 0